import { Tabs } from 'react-vant';
import Info from './components/Info';
import Notice from './components/Notice';
import { Helmet } from '@umijs/max';
import { useState } from 'react';

const Announcement = () => {
  const [activeTab, setActiveTab] = useState('Notice');
  const itemList = [
    {
      key: 1,
      label: '通知公告',
      name: 'Notice',
    },
    {
      key: 2,
      label: '公示信息',
      name: 'Info',
    },
  ];

  const tabChange = (name: any) => {
    setActiveTab(name)
  };
  return (
    <div className="demo-tabs">
      <Helmet>
        <title>公告公示</title>
      </Helmet>
      <Tabs  active={activeTab} sticky={true} onChange={tabChange}>
        {itemList.map((item) => (
          <Tabs.TabPane key={item.key}  name={item.name} title={`${item.label}`} >
            {item.key === 1   ? (
              activeTab === item.name &&
              <>
                <Notice></Notice>
              </>
            ) : (
              activeTab === item.name &&
              <>
                <Info></Info>
              </>
            )}
          </Tabs.TabPane>
        ))}
      </Tabs>
    </div>
  );
};

export default Announcement;
